<template>
  <div class="sector-box">
    <div class="sector-top">
      <div class="sector-title"><img src="@/assets/images/hot.png" />热门板块</div>
      <!-- <div class="sector-goto" @click="onClickRoute">查看全部<i class="el-icon-arrow-right"></i></div> -->
    </div>
    <div class="sector-ul">
      <div
        class="sector-li"
        v-for="(item, index) in sectorList"
        :key="index"
        :class="{ active: activeIndex === index }"
        @click="onSelectItem(item, index)"
      >
        <img v-if="item.sectionAvatar && item.sectionAvatar.url != undefined" :src="item.sectionAvatar.url" alt="img" />
        <div class="sector-text">
          <div class="sector-h">{{ item.sectionName }}</div>
          <div class="sector-p">{{ item.onlineNumber }}人在聊</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sector',
  props: {
    sectorList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      activeIndex: null // 默认选中第一个
    };
  },
  methods: {
    onClickRoute() {
      this.$router.push(`/Sector`)
    },
    onSelectItem(item, index) {
      this.activeIndex = index;
      this.$emit('onSelectItem', item);
    }
  }
}
</script>


<style scoped lang="less">
.sector-box {
  border-radius: 12px;
  margin-top: 20px;
  background: #fff;
}

.sector-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;

  .sector-title {
    display: flex;
    align-items: center;
    color: #262626;
    font-size: 16px;

    img {
      width: 16px;
      margin-right: 4px;
    }
  }

  .sector-goto {
    color: #525252;
    font-size: 12px;
    cursor: pointer;
  }
}

.sector-ul {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 12px 14px 12px;
  justify-content: space-between;
  .sector-li.active{
    background: rgba(156, 29, 34, 0.8);
    .sector-text {
      .sector-h {
        color: #fff;
      }
      .sector-p {
        color: #fff;
      }
    }
  }
  .sector-li {
    background: #F5F5F5;
    width: calc(25% - 4.5px);
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    padding: 8px 10px;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;

    .sector-text {
      text-align: left;

      .sector-h {
        color: #171717;
        font-size: 14px;
        line-height: 18px;
      }

      .sector-p {
        color: #404040;
        font-size: 12px;
        line-height: 12px;
        margin-top: 5px;
      }
    }

    img {
      width: 42px;
      height: 42px;
      border-radius: 6px;
      margin-right: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ForumCenter/components/sector.vue